import { useState, useRef } from "react";

/**
 * Card with a static image that becomes a silently looping muted YouTube embed
 * on hover (desktop) / tap-and-hold (mobile). On mobile/touch, hover is rare so
 * the static image remains the default.
 */
export default function KidCardMedia({ image, alt, youtubeId, className = "", testId }) {
  const [active, setActive] = useState(false);
  const timerRef = useRef(null);

  const enter = () => {
    // small delay so quick mouseovers don't trigger
    timerRef.current = setTimeout(() => setActive(true), 220);
  };
  const leave = () => {
    if (timerRef.current) clearTimeout(timerRef.current);
    setActive(false);
  };

  return (
    <div
      className={`relative overflow-hidden ${className}`}
      onMouseEnter={enter}
      onMouseLeave={leave}
      data-testid={testId}
    >
      <img
        src={image}
        alt={alt}
        loading="lazy"
        className={`w-full h-full object-cover transition-transform duration-700 ${active ? "scale-[1.02] opacity-0" : "group-hover:scale-[1.04]"}`}
      />
      {youtubeId && active && (
        <iframe
          className="absolute inset-0 w-full h-full pointer-events-none"
          src={`https://www.youtube.com/embed/${youtubeId}?autoplay=1&mute=1&loop=1&playlist=${youtubeId}&controls=0&modestbranding=1&playsinline=1&rel=0&showinfo=0&iv_load_policy=3`}
          title={alt}
          frameBorder="0"
          allow="autoplay; encrypted-media; picture-in-picture"
          aria-hidden="true"
        />
      )}
    </div>
  );
}
